export default class DeptPageItems {
    current = 0;
    pages = 0;
    size = 0;
    total = 0;
    pid = "";
    pName = "层级选择";
}
